import { useEffect, useReducer } from "react";
import { Input, InputProps } from "./input"; // Shandcn UI Input

interface TextInputProps extends InputProps {
    onValueChange?: (value: number) => void;
    min?: number;
    max?: number;
}

export default function PercentageInput({ onValueChange, min, max, ...props }: TextInputProps) {
    const [value, setValue] = useReducer(
        (_: any, next: string) => {
            const digits = next.replace(/\D/g, "");
            const realValue = Math.max(min || 0, Math.min(max || 1, Number(digits) / 100));
            return `${Math.round(realValue * 100)} %`;
        },
        props.value ? `${Math.round(Number(props.value) * 100)} %` : ""
    );

    function handleChange(formattedValue: string) {
        const digits = formattedValue.replace(/\D/g, "");
        const realValue = Math.max(min || 0, Math.min(max || 1, Number(digits) / 100));

        if (onValueChange) {
            onValueChange(realValue);
        }
    }

    useEffect(() => {
        setValue(props.value ? `${Math.round(Number(props.value) * 100)} %` : "");
    }, [props.value]);

    return (
        <Input
            {...props}
            type="text"
            onChange={ev => {
                setValue(ev.target.value);
                handleChange(ev.target.value);
            }}
            value={value}
        />
    );
}
